import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { OrgManipulation } from "./OrgManipulation";
import { UserManipulation } from "./UserManipulation";
import { CustomManipulation } from "./CustomManipulation";
import DownloadTemplateLoadingOrder from "../DownloadTemplate/DownloadTemplateLoadingOrder";
import React, {useEffect, useState} from "react";
import DownloadTemplateBol from "../DownloadTemplate/DownloadTemplateBol";
import DownloadTemplateMan from "../DownloadTemplate/DownloadTemplateMan";
import {axiosPostAddFiles} from "../../Api/ApiFiles/axiosPostAddFiles";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {axiosGetListFiles} from "../../Api/ApiFiles/axiosGetListFiles";
import {axiosDeleteFiles} from "../../Api/ApiFiles/axiosDeleteFiles";
import useShowDownloadTemplate from "../../utils/CustomHooks/useShowDownloadTemplate/useShowDownloadTemplate";
import { USER_GET_ALL_USERS } from "../../Api/axios";
import {axiosGetRequest} from "../../Api/axiosGetRequest";

const ProfileUser = () => {

  const { auth, stateReducer, updateRequestFiles } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [listAllUsers, setListAllUsers] = useState([]);
  const [isTemplateLoadingOrder, setTemplateLoadingOrder] = useState({});
  const [isTemplateBol, setTemplateBol] = useState({});
  const [isTemplateMan, setTemplateMan] = useState({});
  const [isFileSelectedLoadingOrder, setFileSelectedLoadingOrder] = useState(false);
  const [isFileSelectedBol, setFileSelectedBol] = useState(false);
  const [isFileSelectedMan, setFileSelectedMan] = useState(false);
  const [selectedFileNameLoadingOrder, setSelectedFileNameLoadingOrder] = useState('Select file');
  const [selectedFileNameBol, setSelectedFileNameBol] = useState('Select file');
  const [selectedFileNameMan, setSelectedFileNameMan] = useState('Select file');
  const [isListDocLoadingOrder, setListDocLoadingOrder] = useState([]);
  const [isListDocBol, setListDocBol] = useState([]);
  const [isListDocMan, setListDocMan] = useState([]);
  const [isMessage, setMessage] = useState('');
  const { isShowDownloadButton } = useShowDownloadTemplate(auth);

  useEffect(() => {
  
        let isLoading = true;

        const controller = new AbortController();
        if(auth?.roles[0] === 'ADMIN') {
          axiosGetRequest(axiosPrivate, USER_GET_ALL_USERS, controller, isLoading, setListAllUsers);
        }
        return () => {
            isLoading = false;
            isLoading && controller.abort()
        }
}, [stateReducer.updateRequestUsers])

  function onSelectFileHandlerLoadingOrder(e) {
    const files = e.target.files;
    const file = files[0];
    // const fileName = file.name.replace(/ /g, "--");
    // const random = new Date().getTime();
    // const fileNameForSave = `${random + "_" + fileName}`;
    setSelectedFileNameLoadingOrder(file?.name);
    setFileSelectedLoadingOrder(true);
    const data = new FormData();
    data.append('file', file);
    setTemplateLoadingOrder(data);
  }

  function onSelectFileHandlerBol(e) {
    const files = e.target.files;
    const file = files[0];
    // const fileName = file.name.replace(/ /g, "--");
    // const random = new Date().getTime();
    // const fileNameForSave = `${random + "_" + fileName}`;
    setSelectedFileNameBol(file?.name);
    setFileSelectedBol(true);
    const data = new FormData();
    data.append('file', file);
    setTemplateBol(data);
  }

  function onSelectFileHandlerMan(e) {
    const files = e.target.files;
    const file = files[0];
    // const fileName = file.name.replace(/ /g, "--");
    // const random = new Date().getTime();
    // const fileNameForSave = `${random + "_" + fileName}`;
    setSelectedFileNameMan(file?.name);
    setFileSelectedMan(true);
    const data = new FormData();
    data.append('file', file);
    setTemplateMan(data);
  }

  useEffect(() => {
    if (isFileSelectedLoadingOrder === true) {
      axiosPostAddFiles(
          axiosPrivate,
          'CARGO_CASE',
          auth.user?.organization?.id,
          isTemplateLoadingOrder,
          setSelectedFileNameLoadingOrder,
          setFileSelectedLoadingOrder,
          setTemplateLoadingOrder,
          setMessage,
          updateRequestFiles
      );
    }
  }, [isFileSelectedLoadingOrder]);

  useEffect(() => {
    if (isFileSelectedBol === true) {
      axiosPostAddFiles(
          axiosPrivate,
          'BOL',
          auth.user?.organization?.id,
          isTemplateBol,
          setSelectedFileNameBol,
          setFileSelectedBol,
          setTemplateBol,
          setMessage,
          updateRequestFiles
      );
    }
  }, [isFileSelectedBol]);

  useEffect(() => {
    if (isFileSelectedMan === true) {
      axiosPostAddFiles(
          axiosPrivate,
          'MAN',
          auth.user?.organization?.id,
          isTemplateMan,
          setSelectedFileNameMan,
          setFileSelectedMan,
          setTemplateMan,
          setMessage,
          updateRequestFiles
      );
    }
  }, [isFileSelectedMan]);

   function onHandlerDeleteFile(fileId) {
     axiosDeleteFiles(axiosPrivate,fileId, updateRequestFiles, setMessage)
   }

  useEffect(() => {
    let isLoading = true;
    if ((auth?.roles[0] === 'CAPTAIN' && auth.user?.organization !== undefined) || ((auth?.roles[0] === 'FORWARDER' && auth.user?.organization !== undefined))) {
      axiosGetListFiles(axiosPrivate, 'CARGO_CASE', auth.user.organization.id, isLoading, setListDocLoadingOrder);
      axiosGetListFiles(axiosPrivate, 'BOL', auth.user.organization.id, isLoading, setListDocBol);
      axiosGetListFiles(axiosPrivate, 'MAN', auth.user.organization.id, isLoading, setListDocMan);
    }
    return () => {
      isLoading = false
    }
  },[stateReducer.updateRequestFiles])

  return (
    <div className="profile-user__container">
      <div className="profile-user-personal-data">
        <h4 className="profile-user-title">Personal data</h4>
        <div className="profile-user-data">
          <label className="profile-user-data__label">Surname</label>
          <p>{auth.user?.lastName}</p>
        </div>
        <div className="profile-user-data">
          <label className="profile-user-data__label">Name</label>
          <p>{auth.user?.firstName}</p>
        </div>
        {auth.user?.organization?.name && (
           <>
             <div className="profile-user-data">
               <label className="profile-user-data__label">Organization</label>
               <p>{auth.user?.organization?.name}</p>
             </div>
           </>
        )}
        {auth.user?.port && 
          <>
            <div className="profile-user-data">
               <label className="profile-user-data__label">Port</label>
               <p>{auth.user?.port?.name}</p>
             </div>
          </>
        }
        {isShowDownloadButton && (
            <>
              <div className="profile-user-data">
                <DownloadTemplateLoadingOrder
                    isListDocLoadingOrder={isListDocLoadingOrder}
                    isFileSelected={isFileSelectedLoadingOrder}
                    selectedFileName={selectedFileNameLoadingOrder}
                    nameTemplate={'Loading order'}
                    onSelectFileHandlerLoadingOrder={onSelectFileHandlerLoadingOrder}
                    onHandlerDeleteFile={onHandlerDeleteFile}
                    isMessage={isMessage}
                />
              </div>
              <div className="profile-user-data">
                <DownloadTemplateBol
                    isListDocBol={isListDocBol}
                    isFileSelected={isFileSelectedBol}
                    selectedFileName={selectedFileNameBol}
                    nameTemplate={'bill of lading'}
                    onSelectFileHandlerBol={onSelectFileHandlerBol}
                    onHandlerDeleteFile={onHandlerDeleteFile}
                    isMessage={isMessage}
                />
              </div>
              <div className="profile-user-data">
                <DownloadTemplateMan
                    isListDocMan={isListDocMan}
                    isFileSelected={isFileSelectedMan}
                    selectedFileName={selectedFileNameMan}
                    nameTemplate={'manifest'}
                    onSelectFileHandlerMan={onSelectFileHandlerMan}
                    onHandlerDeleteFile={onHandlerDeleteFile}
                    isMessage={isMessage}
                />
              </div>
              <p className="download-template__error-message">{isMessage}</p>
            </>
        )}
      </div>
      {auth?.roles[0] === "ADMIN" && (
        <div className="profile-user-block">
          <OrgManipulation />
          <UserManipulation 
            listAllUsers={listAllUsers}
          />
          <CustomManipulation 
            listAllUsers={listAllUsers}
          />
        </div>
      )}
    </div>
  );
};
export default ProfileUser;
